import gql from "graphql-tag"

/* ========== LatestNews ======== */
const LatestNews = gql`
query LatestNews{
  blogs(sort:"createdAt:desc", where:{publish:true, categories_nin:["Investments"]}, limit:12){
    id
    title
    slug
    embed_video_url
    tile_image{
      url
      alternativeText
    }
    tags
    imagetransforms
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }
}`

/* ========== Featured Properties ======== */
const FeaturedProperties = gql`
query FeaturedProperties($department:String!, $search_type:String!){
  properties(sort:"price:desc",where:{publish:true, department:$department, search_type:$search_type, status_in:["For Sale", "Sale Agreed", "To Let"]}, limit:12){
    id
    crm_id
    display_address
    title
    slug
    department
    status
    search_type
    price
    price_qualifier
    bedroom
    bathroom
    parking
    reception
    images
    imagetransforms
    available_from
    extra
    property_type
    office_crm_id
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }
}`

/* ========== Featured Properties Office ======== */
const FeaturedPropertiesOffice = gql`
query FeaturedPropertiesOffice($department:String!, $office_crm_id: [String!]!){

  sale_properties:properties(sort:"price:desc",where:{publish:true, department:$department, search_type:"sales", office_crm_id_in: $office_crm_id, status_in:["For Sale", "Sale Agreed"]}, limit:12){
    id
    crm_id
    display_address
    title
    slug
    department
    status
    search_type
    price
    price_qualifier
    bedroom
    bathroom
    parking
    reception
    images
    imagetransforms
    available_from
    extra
    property_type
    office_crm_id
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }
  let_properties:properties(sort:"price:desc",where:{publish:true, department:$department, search_type:"lettings", office_crm_id_in: $office_crm_id, status_in:["To Let"]}, limit:12){
    id
    crm_id
    display_address
    title
    slug
    department
    status
    search_type
    price
    price_qualifier
    bedroom
    bathroom
    parking
    reception
    images
    imagetransforms
    available_from
    extra
    property_type
    office_crm_id
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }

  recent_let_properties:properties(sort:"sort_date:desc",where:{publish:true, department:"residential", search_type:"lettings", status_in:["Let Agreed"]}, limit:12){
    id
    crm_id
    display_address
    title
    slug
    department
    status
    search_type
    price
    price_qualifier
    bedroom
    bathroom
    parking
    reception
    images
    imagetransforms
    available_from
    extra
    property_type
    office_crm_id
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }

  newhomes_properties:properties(sort:"price:desc",where:{publish:true, department:"residential", search_type:"sales", officeDepartment:"New Homes", status_in:["For Sale"]}, limit:12){
    id
    crm_id
    display_address
    address
    title
    slug
    department
    status
    search_type
    price
    price_qualifier
    bedroom
    bathroom
    parking
    reception
    images
    imagetransforms
    available_from
    extra
    property_type
    office_crm_id
    officeDepartment
    selling_info
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }

  student_properties:properties(sort:"price:desc",where:{publish:true, officeDepartment:"Student", status_in:["To Let"]}, limit:12){
    id
    crm_id
    display_address
    address
    title
    slug
    department
    status
    search_type
    price
    price_qualifier
    bedroom
    bathroom
    parking
    reception
    images
    imagetransforms
    available_from
    extra
    property_type
    office_crm_id
    officeDepartment
    selling_info
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }

}`


/* ========== Featured Properties Area Guide ======== */
const FeaturedPropertiesAreas = gql`
query FeaturedPropertiesAreas($department:String!, $search_type:String!, $area_name:String!){
  properties(sort:"price:desc",where:{publish:true, department:$department, search_type:$search_type, display_address_contains: $area_name, status_in:["For Sale", "Sale Agreed", "To Let", "Let"]}, limit:12){
    id
    crm_id
    display_address
    title
    slug
    department
    status
    search_type
    price
    price_qualifier
    bedroom
    bathroom
    parking
    reception
    images
    imagetransforms
    available_from
    extra
    property_type
    office_crm_id
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }
}`

/* ========== BurgerMenu ======== */
const BurgerMenu = gql`
query BurgerMenu{
  burgerMenus(sort:"sort:asc"){
    id
    label
    custom_link
    menu{
      id
      slug
      label
      link_type
      parent{
        slug
        parent{
          slug
        }
      }
    }
    add_menu{
      id
      label
      custom_link
      target
      menu{
        slug
        parent{
          slug
          parent{
            slug
          }
        }
      }
      sub_menus{
        label
        custom_link
        target
        menu_item{
          slug
          parent{
            slug
            parent{
              slug
            }
          }
        }
      }
    }
  }
}`


/* ========== TeamFilter ======== */
const TeamFilter = gql`
query TeamFilter($category:String!){
  teams(sort:"sort:asc",where:{category_contains:$category}){
    id
    title
    name
    slug
    category
    designation
    email
    mobile_no
    content
    image{
      url
      alternativeText
    }
    imagetransforms
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }
}`


/* ========== Property Details ======== */
const PropertyDetails = gql`
query PropertyDetails($id: String!){  

  globalModule{
    property_details{
      show_calculators
      show_nego_details
      show_speak_with_advisor
      show_similar_properties
      show_property_journey_banner
      show_sell_your_property
    }
  }

  properties(where:{id: $id, publish:true}) {
    id
    crm_id
    office_crm_id
    status
    floorarea_max
    floorarea_min
    floorarea_type
    building
    search_type
    department
    building
    address
    area
    display_address
    title
    slug
    price
    reception
    bedroom
    bathroom
    floorplan
    images
    imagetransforms
    virtual_tour
    crm_negotiator_id
    description
    long_description
    latitude
    longitude
    introtext
    extra
    brochure
    price_qualifier
    parking
    accomadation_summary
    video_tour
    epc
    letting_info
    council_tax
    selling_info
    officeDepartment
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }


}`


/* ========== Property Details ======== */
const PropertyNewhomesChild = gql`
query PropertyNewhomesChild($id: String!){  
  properties(where:{master_id: $id, publish:true}) {
    id
    crm_id
    office_crm_id
    status
    floorarea_max
    floorarea_min
    floorarea_type
    building
    search_type
    department
    building
    address
    area
    display_address
    title
    slug
    price
    reception
    bedroom
    bathroom
    floorplan
    images
    imagetransforms
    virtual_tour
    crm_negotiator_id
    description
    long_description
    latitude
    longitude
    introtext
    extra
    brochure
    price_qualifier
    parking
    accomadation_summary
    video_tour
    epc
    letting_info
    council_tax
    selling_info
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }

}`


/* ========== New homes Details ======== */
const NewHomesDetails = gql`
query NewHomesDetails($id: String!){  

  newDevelopments(where:{id: $id, publish:true}) {
    id
    crm_id
    building
    display_address
    latitude
    longitude
    price
    price_qualifier
    description
    additional_description
    status
    search_type
    bedroom
    images
    accomadation_summary
    floorplan
    crm_negotiator_id
    imagetransforms
    brochure
    address
    selling_info
    office_crm_id
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }

    about_development{
      id
      title
      
      content
      local_padd:padding
      background_color: bg_color
      image_align
      image {
        url
        alternativeText
      }
      accordian_module {
        answer
        question
      }
      button_cta {
        theme
        target
        custom_link
        id
        label
        menu_item {
          slug
          parent {
            slug
            parent {
              slug
              parent {
                slug
              }
            }
          }
        }
      }
    }
  }


}`

/* ========== Office List ======== */
const OfficeList = gql`
query OfficeList{
  offices(sort:"sort:ASC", where:{publish:true}){
    id
    slug
    name
    address
  	mobile
    email
    office_crm_id
    areas{
      id
      area_name
    }
    image{
      url
      alternativeText
    }
    imagetransforms
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
    sort
  }
}`

/* ========== Area Guide List ======== */
const AreaGuideList = gql`
query AreaGuideList{
  areaGuides(sort:"title:ASC", where:{publish:true}){
    id
    title
    slug
    latitude
    longitude
    banner_image {
      alternativeText
      url
    }
    tile_image{
      alternativeText
      url
    }
      content 
    imagetransforms
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }
}`

/* ========== Area List ======== */
const AreaList = gql`
query AreaList{
  areas{
  	id
  	area_name
	}
}`

/* ========== PopularSearch ======== */
const PopularSearch = gql`
query PopularSearch($slug: String!){
  menus(where:{slug:$slug}){
    id
    label
    slug
    popular_search{
      popular_search{
        title
        content
      }
    }
  }
}`

/* ========== New Homes Properties ======== */
const NewHomesProperties = gql`
query NewHomesProperties($master_id: String!){
  newDevelopments(where:{id_nin: $master_id, publish:true}, limit:12) {
    id
    crm_id
    building
    display_address
    latitude
    longitude
    price
    max_price
    slug
    price_qualifier
    description
    additional_description
    status
    search_type
    bedroom
    address
    images
    accomadation_summary
    floorplan
    crm_negotiator_id
    imagetransforms
    brochure
    address
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  }
}`


/* ========== News Details ======== */
const NewsDetails = gql`
query NewsDetails($slug: String!){
  blogs(where:{slug:$slug}) {
    id
    title
    description
    categories
    tags
    embed_video_url
    slug
    createdAt
    banner_image {
      alternativeText
      url
    }
    author {
      name
    } 
    seo {
      title
      keywords
      description
      id
      image {
        alternativeText
        url
      }
    }
    imagetransforms
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }
  } 
}`

/* ========== Office Details ======== */
const OfficeDetails = gql`
query OfficeDetails($slug: String!){
  offices(where:{slug:$slug}) {
    id
    slug
    publish
    latitude
    longitude
    office_crm_id
    name
  } 
}`

/* ========== Office Details ======== */
const OfficeDetailsID = gql`
query OfficeDetailsID($crm_id: String!){
  offices(where:{office_crm_id_contains:$crm_id, publish:true}) {
    id
    slug
    publish
    office_crm_id
    name
  } 
}`

/* ========== Get Menu  ======== */
const GetMenu = gql`
query GetMenu($slug: String!){
  menus(where:{slug:$slug}) {
    id
    slug
    label
    page{
      id
      title
    }
  } 
}`

/* ========== BranchDet  ======== */
const BranchDet = gql`
query BranchDet($id: ID!){
  brand(id: $id) {
    id
    slug
    title
    content
    year_acquired
    services_offers
    office_headquaters
    latitude
    longitude
    brand_logo{
        alternativeText
        url
    }
    seo_meta {
      title
      keywords
      description
      id
      image {
        alternativeText
        url
      }
    }
    imagetransforms
    ggfx_results {
      id
      content_type
      transforms
      src_import_url
      src_cftle
      field
    }

    banner_section{
        title
        content
        banner_image{
            alternativeText
            url
        }
        button_cta_2 {
            theme
            target
            label
            id
            custom_link
            menu_item {
              slug
              parent {
                slug
                parent {
                  slug
                  parent {
                    slug
                  }
                }
              }
            }
        }
        button_cta_1 {
            theme
            target
            label
            custom_link
            id
            menu_item {
              slug
              parent {
                slug
                parent {
                  slug
                  parent {
                    slug
                  }
                }
              }
            }
        }
    }

    Add_Modules {
        __typename

        ...on ComponentComponentsShowStatisticsSection{
            show
            statics_blocks{
              heading
              icon_class
              content          
            }
        }

        ...on ComponentComponentsLeadershipComponent{
            title
            leadership_module{
              team{
                id
                name
                slug
                designation
                email
                mobile_no
                imagetransforms
                ggfx_results {
                  id
                  content_type
                  transforms
                  src_import_url
                  src_cftle
                  field
                }
                tile_image{
                  url
                  alternativeText
                }
                
              }
            }
        }

        ... on ComponentComponentsRelatedCaseStudy {
            id
            title
            case_study_modules {
              blog {
                id
                title
                slug
                description
                tile_image {
                  url
                  alternativeText
                }
                imagetransforms
                ggfx_results {
                  id
                  content_type
                  transforms
                  src_import_url
                  src_cftle
                  field
                }
              }
            }
        }
    }
  }
}`


export const Queries = {
  LatestNews,
  FeaturedProperties,
  FeaturedPropertiesOffice,
  BurgerMenu,
  TeamFilter,
  PropertyDetails,
  OfficeList,
  AreaList,
  AreaGuideList,
  PopularSearch,
  NewHomesDetails,
  NewHomesProperties,
  NewsDetails,
  OfficeDetails,
  GetMenu,
  FeaturedPropertiesAreas,
  PropertyNewhomesChild,
  BranchDet,
  OfficeDetailsID
};

